import { render, staticRenderFns } from "./edit-restaurant-product.vue?vue&type=template&id=739cb90e&scoped=true"
import script from "./edit-restaurant-product.vue?vue&type=script&lang=ts"
export * from "./edit-restaurant-product.vue?vue&type=script&lang=ts"
import style0 from "./edit-restaurant-product.vue?vue&type=style&index=0&id=739cb90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739cb90e",
  null
  
)

export default component.exports